<template>
    <div class="report-popup">
        <div class="report-list report-list-top">
            <div class="report-list-item
             report-list-head border-bottom">时间筛选
            </div>
        </div>

        <IScrollView ref="iscrollview" class="iscrollview" :options="options">
            <div class="report-list">
                <div>
                    <div class="report-list-item border-bottom"
                         :class="{active: date === year.value}"
                         v-for="(year, index) in dateList"
                         @click="yearHandler(year)"
                         :key="index">{{year.label }}
                    </div>
                </div>
                <p class="no-data" v-if="dateList.length === 0">暂无数据</p>
            </div>
        </IScrollView>


    </div>
</template>
<script>

    import IScrollView from "../iIScrollView/IScrollView";

    export default {
        props: ['dateList',
            'date'],
        components: {
            IScrollView
        },
        data(){
            return {
                options: {
                    scrollX: false,
                    scrollY: true,
                    click: true,
                    keyBindings: true,
//加入以下三个可解决
                    disablePointer:true,
                    disableTouch:false,
                    disableMouse:true
                },
            }
        },
        watch: {
            dateList: {
                handler() {
                    this.$nextTick(() => {
                        this.$refs.iscrollview.refresh()
                    });
                }, immediate: true
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.iscrollview.refresh()
            })
        },
        methods: {
            yearHandler(item) {
                this.$emit('dateChange', item);
            }
        }
    }
</script>